import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精选推荐</h2>
          <p className="text-sm text-foreground-500 mt-2">高分好评 · 口碑佳作 · 编辑精选</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {cardsData.map((card) => (
            <div
              key={card.id}
              className="group rounded-lg overflow-hidden cursor-pointer transition-all duration-200"
              style={{ backgroundColor: 'oklch(var(--background-100))' }}
            >
              <div className="relative overflow-hidden aspect-[3/4]">
                <img
                  src={card.image}
                  alt={`${card.title} — ${card.author}`}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span
                    className={`px-2 py-0.5 rounded text-xs font-medium ${card.status === '完结' ? '' : ''}`}
                    style={{
                      backgroundColor: card.status === '完结' ? 'oklch(var(--secondary-100))' : 'oklch(var(--primary-100))',
                      color: card.status === '完结' ? 'oklch(var(--secondary-700))' : 'oklch(var(--primary-700))',
                    }}
                  >
                    {card.status}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-800 truncate group-hover:opacity-80 transition-opacity">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{card.author} · {card.category}</p>
                <p className="text-xs text-foreground-400 mt-1.5 line-clamp-2 leading-relaxed">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}